import React from 'react';

import { MCButton, MCText, View } from 'src/components/basic';
import { remCss, rgba, scssVariables as variables } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import { getHospitalLabel } from './doctorDetailUtils';

// `fontSize` is a function (px) => size. Desktop and mobile use different scaling.
const identity = (v) => v;

export const SpecialistChips = ({ specialist = [], fontSize = identity }) => (
  <View style={{ flexDirection: 'row', gap: remCss(10), flexWrap: 'wrap' }}>
    {specialist
      .filter((s) => !!LANG_CONST.constants.specialist[s])
      .map((s) => (
        <MCButton key={s} shadow rounded>
          <MCText
            size={fontSize(20)}
            weight={400}
            heading
            label={LANG_CONST.constants.specialist[s]}
          />
        </MCButton>
      ))}
  </View>
);

export const SubSpeciality = ({ value, fontSize = identity }) => {
  if (!value) return null;
  return (
    <View style={{ gap: remCss(10) }}>
      <MCText label={LANG_CONST.sub_speciality} size={fontSize(18)} weight={400} textLight />
      <View style={{ flexDirection: 'row' }}>
        <MCButton shadow rounded>
          <MCText label={value} size={fontSize(20)} weight={400} heading />
        </MCButton>
      </View>
    </View>
  );
};

export const LocationList = ({ locations, selected, onSelect, fontSize = identity }) => (
  <>
    {locations.map((h) => (
      <MCText
        key={h.id}
        style={{
          cursor: 'pointer',
          ...(selected?.id === h.id
            ? {
                backgroundColor: rgba(variables['colors-mc-primary'], 0.1),
                padding: remCss(10),
                borderRadius: remCss(3)
              }
            : { paddingHorizontal: remCss(10) })
        }}
        onClick={() => onSelect(h)}
        label={getHospitalLabel(h.hospital)}
        size={fontSize(18)}
        weight={500}
        heading
      />
    ))}
  </>
);
